import React from 'react';
import styles from './Card.module.css';

/**
 * Переиспользуемый компонент-карточка для обертывания контента.
 * Принимает все стандартные пропсы для div и дополнительный className.
 */
const Card = ({ children, className, document = false, ...props }) => {
    const cardClassName = `${styles.card} ${className || ''} ${document ? styles['card-document'] : ''}`.trim();

    return (
        <div className={cardClassName} {...props}>
            {children}
        </div>
    );
};

export default Card;
